<template>
    <div class="container-fluid">
        <br>
        <p class="text-header">LIST TRUTH OR DARE</p>
       
        <div class="account-details">
            <div class="col-sm-12 table table-responsive">
                <div class="contract-header">
                    <div> <span class="badge badge-primary">{{ modelCount }}</span> Truth or Dare </div>
                    <div> </div>
                </div>
    
                <div class="table table-responsive table-sm">
                    <v-data-table :headers="header" :items="desserts" dense class="table-striped table-bordered table-responsive">
                        <template v-slot:item.amount="{ item }">
                        <div class="a-text price-pill">{{ formatToCurrency(item.amount) }}</div>
                    </template>
                        <template v-slot:item.status="{ item }">
                            <div class="a-text">
                               <span v-if="item.status == 'pending'" class="text-warning">{{ item.status }}</span> 
                               <span v-if="item.status == 'cancelled'" class="text-danger">{{ item.status }}</span> 
                               <span v-if="item.status == 'accepted'" class="text-success">{{ item.status }}</span> 
                               <span v-if="item.status == 'completed'" class="text-primary">{{ item.status }}</span> 
                            </div>
                        </template>
                      
                        <template v-slot:item.proof_datetime="{ item }">
                            <div class="a-text"> {{ item.proof_datetime }}</div>
                        </template> 
                        <template v-slot:item.deadline="{ item }">
                            <div class="a-text"> {{ new Date(item.deadline).toLocaleDateString()}}</div>
                        </template> 
                        <template v-slot:item.createdat="{ item }">
                            <div class="a-text"> {{ new Date(item.createdat).toLocaleString()}}</div>
                        </template> 
                        <template v-slot:item.proof_media="{ item }">
                            <div class="a-text">
                                <a
                                    v-if="item.proof_media"
                                    :href="getProofMediaUrl(item.proof_media)"
                                    :download="getProofMediaName(item.proof_media)"
                                    target="_blank"
                                    rel="noreferrer"
                                    class="proof-link"
                                >
                                    Download attachment
                                </a>
                                <span v-else class="text-muted">No attachment</span>
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </div>
            
             <!-- Approval Modal -->
        </div>
        <div v-if="showApprovalModal" class="modal-backdrop-custom">
        <div class="modal-wrapper">
            <div class="modal-subs modal-lg shadow-lg rounded-3 overflow-hidden bg-white">
            <!-- Header -->
            <div class="modal-header subs-content text-white">
                <h5 class="modal-title">
                <i class="bi bi-person-check"></i> Approve Model
                </h5>
                <button
                type="button"
                class="btn-close btn-close-white"
                @click="closeApprovalModal"
                ></button>
            </div>

            <!-- Body -->
            <div class="modal-body p-4">
                <div class="d-flex flex-column align-items-center mb-4">
                <!-- User Picture -->
                <img
                    :src="selectedUser.picture || 'https://via.placeholder.com/120'"
                    alt="User Picture"
                    class="rounded-circle border shadow-sm"
                    width="120"
                    height="120"
                />
                </div>

                <!-- User Details (2 columns) -->
                <div class="user-info px-3">
                <div class="row">
                    <div class="col-md-6 mb-3">
                    <strong class="text-muted">Username:</strong>
                    <div>{{ selectedUser.username }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                    <strong class="text-muted">Email:</strong>
                    <div>{{ selectedUser.email }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                    <strong class="text-muted">Phone:</strong>
                    <div>{{ selectedUser.phone }}</div>
                    </div>
                    <div class="col-md-6 mb-3" v-if="selectedUser.age">
                    <strong class="text-muted">Age:</strong>
                    <div>{{ selectedUser.age }}</div>
                    </div>
                    <div class="col-md-6 mb-3">
                    <strong class="text-muted">Location:</strong>
                    <div>{{ selectedUser.location }} {{ selectedUser.state }}</div>
                    </div>
                   
                    <div class="col-md-6 mb-3" v-if="selectedUser.country">
                    <strong class="text-muted">Country:</strong>
                    <div>{{ selectedUser.country }}</div>
                    </div>
                </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer d-flex justify-content-end bg-light px-4">
                <button
                type="button"
                class="btn btn-outline-secondary px-4 me-2"
                @click="closeApprovalModal"
                >
                Cancel
                </button>
                <button type="button" class="btn btn-success px-4" @click="approveUser">
                Approve
                </button>
            </div>
            </div>
        </div>
        </div>
       
        <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    </template>
    
      
    <script>
    //import swal from 'sweetalert2';
    import PageLoader from '../components/PageLoader.vue'

    export default {
    
        name: "AllUsersPage",
        components: {
            //quillEditor,
            PageLoader,
        },
    
        data() {
            return {
    
                isLoading: false,
                isRightImage: false,
                isLeftImage: false,
                isBackImage: false,
                is_transaction_fee: true,
                is_transaction_fee_hidden: false,
                user_id: '',
                firstname: '',
                lastname: '',
                bank_name: '',
                account_name: '',
                account_number: '',
    
                loading: false,
                loading1: false,
                loading2: false,
                loading3: false,
                role_type: '',
                contract_title: '',
                transaction_type: '',
                delivery_type: '',
                delivery_location: '',
                delivery_time: '',
                contract_amount: '',
                transaction_fee: '',
                whois_paying: '',
                contract_rebate: '',
                product_description: '',
                accept_terms: '',
    
                products: [],
                subcategorys: [],
                selectedFile: '',
                selectedFile1: '',
                selectedFile2: '',
                selectedFile3: '',
                addProduct: false,
                viewProduct: true,
                editorOptions: {
                    placeholder: 'Write something...',
                },
    
                isVariations: false,
                productid: '',
                variations: '',
                vprice: '',
                is_fees_status: false,
                is_submit: false,
                is_submit1: false,
                is_submit2: false,
                is_submit3: false,
                img_url: process.env.VUE_APP_IMAGE_URL,
                header: [
                    {
                        value: 'model',
                        text: 'Model'
                    },
                    {
                        value: 'client',
                        text: 'Client'
                    },
                    {
                        value: 'amount',
                        text: 'Amount(DRT)'
                    },             
                    {
                        value: 'request_type',
                        text: 'Request'
                    },
                    {
                        value: 'request_details',
                        text: 'Details'
                    },
                    {
                        value: 'deadline',
                        text: 'Deadline'
                    },
                    {
                        value: 'proof_media',
                        text: 'Proof'
                    },
                    {
                        value: 'proof_datetime',
                        text: 'Proof datetime'
                    },
                    {
                        value: 'status',
                        text: 'Status'
                    },
                   
                    {
                        value: 'createdat',
                        text: 'Date submiited'
                    },
                   
                   
                ],
    
                desserts: [],
                user_role: '',
                product_id: '',
                userid: '',
                modelCount: '',
            
                modelData: [],
                isPeriod: false,
                delivery_period: '',
                payment_status: '',
                is_escrow_charge: false,
                error: '',
                error1: '',
                duration_twelve: false,
                duration_twelve1: true,
                label1: '',
                isContractLink: false,
                contractLink: '',
                service_charge_fee: '',

                showApprovalModal: false,
                selectedUser: {
                    picture: "",
                    username: "",
                    email: "",
                    phone: "",
                    age: "",
                    country: "",
                    location: "",
                    state: "",
                },
            };
        },
    
        beforeMount() {
    
        },
    
        async mounted() {
    
            this.firstname = localStorage.getItem("firstname");
            this.lastname = localStorage.getItem("lastname");
            this.phone_number = localStorage.getItem("phone");
            this.email_address = localStorage.getItem("email");
            this.user_id = localStorage.getItem("userid");
    
            this.bank_name = localStorage.getItem("bank_name");
            this.account_name = localStorage.getItem("account_name");
            this.account_number = localStorage.getItem("account_number");
            this.user_role = localStorage.getItem("user_role");
    
            await this.fetchAllBookings()
        },
    
        created() {
    
        },
    
        computed: {

            indexSn() {
                return this.desserts.map((d, index) => ({
                    ...d,
                    sn: index + 1
                }))
            },
    
        },
    
        methods: {
            validateNumber() {
            const value = this.delivery_period;
            if (value < 0) {
              this.error = 'Value must be non-negative';
              this.delivery_period = ''
              return
            } else if (!Number.isInteger(Number(value))) {
              this.error = 'Value must be an integer';
              this.delivery_period = ''
              return
            } else {
              this.error = '';
            }
          },
    
            formatToCurrency(value) {
              return value.toLocaleString('en-NG', { minimumFractionDigits: 0 })
            },
    
           
            copied(){
                this.isContractLink = false
            },
    
            copyToClipboard(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
    
            copyToClipboard1(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
            getProofMediaUrl(media) {
                if (!media) return '';

                if (/^https?:\/\//i.test(media)) {
                    return media;
                }

                const baseUrl = this.img_url || '';
                const trimmedBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
                const trimmedMedia = String(media).startsWith('/') ? String(media).slice(1) : String(media);

                return `${trimmedBase}/${trimmedMedia}`;
            },

            getProofMediaName(media) {
                if (!media) return 'attachment';

                const cleanMedia = String(media).split('?')[0].split('#')[0];
                const parts = cleanMedia.split('/');
                return parts[parts.length - 1] || 'attachment';
            },

            formatDateTime(value) {
                if (!value) return '';

                const date = new Date(value);
                if (Number.isNaN(date.getTime())) {
                    return value;
                }

                return date.toLocaleString('en-NG', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true,
                });
            },
            async fetchAllBookings() {
                try {
                    this.isLoading = true
                    this.desserts = []
                    const response = await this.$http.get('/fetch-truthdare', {
                        //user_id: this.user_id
                    })
                    this.isLoading = false
                    
                    //let photo_url = '';
                    this.modelData = response.data.data
                    this.modelCount = this.modelData.length
                    this.modelData.forEach(el => {
                        this.desserts.push({
                            model: el.model_name,
                            client: el.guest_name,
                            amount: el.dayruns_token,
                            request_type: el.request_type,
                            request_details: el.request_details,
                            deadline: el.deadline,
                            proof_media: el.proof_media,
                            proof_datetime: this.formatDateTime(el.proof_datetime),
                            status: el.status,
                            createdat: el.created_at
                        })
                    });
    
                } catch (err) {
                    console.log(err);
                }
            },

            openApprovalModal(user) {
            console.log(user)
            this.showApprovalModal = true;
            this.selectedUser = {
                picture: user.photo_url || "",
                username: user.username || "",
                email: user.email || "",
                phone: user.phone || "",
                age: user.age || "",
                country: user.country || "",
                location: user.location || "",
                state: user.state || "",
            };
           
            },
            closeApprovalModal() {
            this.showApprovalModal = false;
            },
            approveUser(user) {
            // Handle approval logic here
              console.log("User approved:", user);

            },
    
        }
    
    }
    </script>
      
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
    .container-fluid {
        min-height: 100vh;
        padding: 24px;
        background:
            radial-gradient(circle at top left, rgba(211, 62, 116, 0.12), transparent 30%),
            radial-gradient(circle at top right, rgba(8, 41, 74, 0.10), transparent 26%),
            linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%);
        font-family: Poppins;
    }
    .text-header {
        margin: 0 0 18px;
        padding: 18px 22px;
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.92);
        border: 1px solid rgba(15, 23, 42, 0.08);
        box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
        color: #081b2d;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }
    .account-details {
        width: 100%;
        border-radius: 24px;
        padding: 20px;
        background: rgba(255, 255, 255, 0.92);
        border: 1px solid rgba(15, 23, 42, 0.08);
        box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
    }
    .contract-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        padding: 0 0 16px;
        margin-bottom: 16px;
        background: transparent;
        border-bottom: 1px solid #e8edf3;
        color: #081b2d;
        border-radius: 0;
        font-size: 14px;
        font-weight: 700;
    }
    .v-data-table {
        font-family: Poppins;
    }
    .v-data-table ::v-deep thead th {
        background: #f8fafc;
        color: #334155;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        white-space: nowrap;
    }
    .v-data-table ::v-deep tbody td {
        font-size: 13px;
        color: #0f172a;
        vertical-align: middle;
    }
    .a-text {
        font-size: 13px;
        color: #334155;
        font-family: Poppins;
    }
    .proof-link {
        color: #d33e74;
        font-weight: 600;
        text-decoration: none;
    }
    .proof-link:hover {
        text-decoration: underline;
    }
    .modal-wrapper {
        max-width: 680px;
    }
    .modal-subs {
        border-radius: 24px;
    }
    /* Dark backdrop */
/* Backdrop */
    .modal-backdrop-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    }

    /* Modal wrapper (center container) */
    .modal-wrapper {
    width: 100%;
    max-width: 600px;
    }

    /* Header */
    .subs-content {
    padding: 0.5rem;
    background-color: #D33E74; /* Bootstrap success green */
    }
    .btn-success{
        background-color: #D33E74; 
        border: 0px;
    }
    .btn-xs{
        padding: 0.2rem;
        border: 0px;
        font-family: Poppins;
        font-size: 12px;
        font-weight: 500;
    }
    .modal-footer{
        padding: 0.5rem;
    }
    /* User info */
    .user-info p {
    font-size: 1rem;
    color: #222;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 8px;
    }
    .user-info p:last-child {
    border-bottom: none;
    }

    .user-info strong {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 4px;
  color: #6c757d;
}
.user-info div {
  font-size: 1rem;
  color: #212529;
  font-weight: 500;
}

    .error {
        color: #fff;
      }
      .error1 {
        color: #fff;
      }
    .quill-container {
        height: 200px;
        /* Set the desired height here */
    }
    .copy-refid{
        cursor: pointer;
        font-size: 16px;
    }
    .copy-refid1{
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
    }
    .a-text {
        font-size: 12px;
        font-family: Poppins;
    }
    .a-text1 {
        font-size: 14px;
        font-family: Poppins;
    }
    .process-payment{
        cursor:pointer;
    
    }
    label {
        font-size: 12px;
        font-family: Poppins;
        font-weight: normal;
    }
    
    .inputs {
        margin-top: 20px;
        border-radius: 3px;
        font-size: 12px;
    }
    
    .price-fee {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        div {
            margin: 4px;
            width: 100%;
    
        }
    }
    
    .adjust-fee-input {
        // width: 100px;
        text-align: center;
    }
    
    .whopays-fee-input {
        //width: 100% !important;
    }
    
    .shop-detail {
        font-size: 12px;
        font-family: Poppins;
    }
    
    .btn-danger {
        text-transform: uppercase;
        font-size: 13px;
        font-family: Poppins;
        background: #D33E74;
        border: 0px;
        height: 45px;
    }
    
    .text-header {
        padding: 0.5rem;
        font-size: 14px;
        font-weight: bold;
        font-family: Poppins;
        background: #ccc;
    }
    
    .contract-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #D33E74;
        color: #fff;
        border-radius: 4px;
        padding: 0.8rem;
        font-size: 14px;
        font-weight: 700;
        font-family: Poppins;
        margin-bottom: 5px;
    }
    
    .welcome {
        font-family: Poppins;
        font-size: 20px;
        font-weight: 700;
        margin-top: 15px;
        color: #170e0fac;
    }
    
    .account-details {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        //padding: 0.9rem;
        background: #fff;
        width: 98%;
    }
    
    .account-balance {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #780712;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .wallet-detail {
        padding-top: 1rem;
        line-height: 1.4px;
        font-size: 15px;
    
        h4 {
            font-weight: 650;
        }
    
        .acct-d {
            line-height: 0.8;
            cursor: pointer;
            text-decoration: underline;
        }
    }
    
    .wallet-icon {
        font-size: 60px
    }
    
    .fund-account {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #076378;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .inputs-field {
        font-size: 14px;
        font-family: Poppins;
        height: 45px;
    }
    
    .content-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: solid 1px #170e0fac;
        border-radius: 4px;
        padding: 0.5rem;
        margin: 4px;
    }
    
    .box1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .image-input {
        margin-top: 10px;
    }
    
    .box-icon {
        padding-left: 0.4rem;
        font-size: 35px;
        color: #637807;
    }
    
    .box-details {
        font-size: 14px;
        color: #170e0fac;
    }
    
    .box1:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box2:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box3:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box4:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box5:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box6 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box6:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .img {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    
    .box-details {
        padding: 0.4rem;
        line-height: 1.4px;
    
        .title {
            font-family: Poppins;
            font-weight: 550;
            font-size: 10px;
            text-transform: capitalize;
            color: #ff4d63;
        }
    
        .description {
            font-family: Poppins;
            font-size: 12px;
        }
    }
    
    .continue {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding-right: 0.4rem;
        font-size: 30px;
        color: rgb(237, 138, 108);
        margin-right: 10px;
        margin-top: -10px;
        margin-bottom: 10px;
    }
    
    .modal-mask {
        position: fixed;
        //z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
    
        &>div {
            width: 90%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            ;
            backdrop-filter: blur(13px);
            border-radius: 10px;
            box-sizing: border-box;
            font-family: Poppins;
        }
    
        h3 {
            margin-top: 10px;
            font-size: 18px;
            color: #000;
            font-weight: bold;
            font-family: Poppins;
        }
    }
    
    .account-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .account-content-h {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
    
        padding-top: 1.3rem;
        text-transform: uppercase;
        text-align: center;
        //text-decoration: underline;
    }
    
    .add-fund {
        font-size: 12px;
        text-decoration: none !important;
        text-transform: capitalize;
    }
    
    .account-content-d {
        padding-top: 1.3rem;
        font-size: 14px;
        margin-bottom: 10px;
    }
    
    .btn-secondary {
        text-transform: uppercase;
    }
    
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    }
    
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    
        display: none;
    }
    
    a {
        text-decoration: none;
    }
    
    .shop-name {
        //font-weight: 550;
        color: #000;
        font-family: Poppins;
    }

    .text-header {
        margin: 0 0 18px;
        padding: 18px 22px;
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.92);
        border: 1px solid rgba(15, 23, 42, 0.08);
        box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
        color: #081b2d;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }
    .contract-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        padding: 0 0 16px;
        margin-bottom: 16px;
        background: transparent;
        border-bottom: 1px solid #e8edf3;
        color: #081b2d;
        border-radius: 0;
        font-size: 14px;
        font-weight: 700;
    }
    .account-details {
        width: 100%;
        border-radius: 24px;
        padding: 20px;
        background: rgba(255, 255, 255, 0.92);
        border: 1px solid rgba(15, 23, 42, 0.08);
        box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
    }
    .v-data-table {
        font-family: Poppins;
    }
    .v-data-table ::v-deep thead th {
        background: #f8fafc;
        color: #334155;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        white-space: nowrap;
    }
    .v-data-table ::v-deep tbody td {
        font-size: 13px;
        color: #0f172a;
        vertical-align: middle;
    }
    .a-text {
        font-size: 13px;
        color: #334155;
        font-family: Poppins;
    }
    
    @media screen and (max-width: 768px) {
        .container-fluid {
            padding: 14px;
        }

        .text-header {
            padding: 14px 16px;
            border-radius: 16px;
        }

        .account-details {
            padding: 14px;
            border-radius: 18px;
        }

        .contract-header {
            flex-direction: column;
            align-items: stretch;
        }

        .copy-refid1{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
        }
        .inputs-field {
            font-size: 12px;
            font-family: Poppins;
            font-weight: normal;
            height: 45px;
        }
        .contract-header {
    
            font-size: 12px !important;
    
        }
    
        .counter {
            font-size: 13px;
            font-weight: 500 !important;
        }
    
        .welcome {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #170e0fac;
        }
    
        .content-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.9rem;
        }
    
        .image-input {
            margin-top: 20px;
        }
    
        .price-fee {
            display: flex;
            flex-direction: column;
    
            div {
                width: 100%;
            }
        }
        .margin-mobile{
            margin-top: 90px;;
        }
    
        .adjust-fee-input {
            width: 100%;
        }
    
        .account-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 100%;
        }
    
        .account-balance {
            margin-bottom: 10px;
        }
    
        .box-details {
            padding: 0.4rem;
            line-height: 1.4px;
    
            .title {
                font-family: Poppins;
                font-weight: 550;
                font-size: 8px;
                text-transform: capitalize;
                color: #ff4d63;
            }
    
            .description {
                font-family: Poppins;
                font-size: 12px;
            }
        }
    
        .inputs {
            font-size: 12px;
        }
    
        .box1 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box2 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box3 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box4 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box5 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .continue {
            display: flex;
            flex-direction: row;
            justify-content: right;
            padding-right: 0.4rem;
            font-size: 30px;
            margin-top: -10px;
            color: rgb(237, 138, 108);
        }
    
        .modal-close-mobile {
            display: block;
        }
    
        .modal-close {
            display: none;
        }
    
        .account-content {
            margin: 0px;
            margin-right: 0px;
        }
    
    }
    </style>
    
